import { useState } from "react";
import side from "./images/side.jpg";
import axios from "axios";

const CareerPage = () => {
  const [showOtherSkill, setShowOtherSkill] = useState(false);
  const [photo, setPhoto] = useState('')
  const [resume, setResume] = useState('')
  const form = new FormData();

  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    course: "",
    year_of_passing: "",
    major_skill: "",
    other_skill: "",
    photo: null,
    resume: null 
  });


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: file, // Update the corresponding file field in state
      }));
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a FormData object to send files and other data
    const form = new FormData();
    form.append("name", formData.name);
    form.append("contact", formData.contact);
    form.append("email", formData.email);
    form.append("course", formData.course);
    form.append("year_of_passing", formData.year_of_passing);
    form.append("major_skill", formData.major_skill);
    form.append("photo", formData.photo);  
    form.append("resume", formData.resume);  
    console.log(formData.resume);
    console.log(formData.photo);

    try {
      const response = await axios.post("https://versai.in/api/sendForm.php", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(response.data);
    } catch (error) {
      alert("Failed to submit application. Please try again.");
      console.error("Error:", error);
    }
  };



  return (
    <div>
      {/* Breadcrumb Area */}
      <section
        className="relative overflow-hidden text-center py-24 md:py-36 banner-6 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1526948128573-703ee1aeb6fa?fit=crop&w=1920&h=400')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-white to-white opacity-85 z-0"></div>
        <div className="relative z-10 text-gray-700">
          <div className="container mx-auto">
            <div className="flex justify-center items-center">
              <div className="space-y-6">
                <div className="fadeInUp">
                  <ul className="inline-flex space-x-2 text-lg">
                    <li>
                      <p className=" text-3xl text-gray-700">Careers</p>
                    </li>
                  </ul>
                </div>
                <div className="fadeInUp">
                  <h2 className="text-1xl font-semibold leading-relaxed">
                    Join Versai Tech Solutions
                    <br />
                    Submit your details to apply for open positions.
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Career Form */}
      <section className="career-page px-8 md:px-11 py-8 md:py-16">
        <div className="container mx-auto">
          <div className="flex flex-wrap justify-center gap-10 xl:gap-20 items-start space-y-8 md:space-y-0 lg:space-y-8 ">
            {/* Form */}
            <div className="w-full xl:w-2/3 max-w-2xl">
              <div className="text-left mb-8">
                <span className="text-sky-600 text-lg uppercase">
                  Apply Now
                </span>
                <h2 className="text-3xl font-bold mt-4">
                  Start Your Career With Us
                </h2>
                <p className="mt-6 mb-8">
                  Fill out the form below and attach the required documents to
                  apply for a position at Versai Tech Solutions.
                </p>
              </div>
              <form
                onSubmit={handleSubmit}
                className="space-y-6"
              >


                {/* Apply grid for inputs */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter name"
                    onChange={handleInputChange}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(
                        /[^A-Za-z\s]/g,
                        ""
                      ); // Remove numbers and special symbols
                    }}
                    className="border-b-2 border-gray-300 focus:border-sky-600 py-2 px-4 w-full"
                    required
                  />

                  <input
                    type="text"
                    name="contact"
                    placeholder="Enter contact number"
                    onChange={handleInputChange}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
                    }}
                    className="border-b-2 border-gray-300 focus:border-sky-600 py-2 px-4 w-full"
                    required
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="Enter email"
                    onChange={handleInputChange}
                    pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                    title="Please enter a valid email address."
                    className="border-b-2 border-gray-300 focus:border-sky-600 py-2 px-4 w-full"
                    required
                  />

                  <input
                    type="text"
                    name="course"
                    placeholder="Enter course"
                    onChange={handleInputChange}
                    className="border-b-2 border-gray-300 focus:border-sky-600 py-2 px-4 w-full"
                    required
                  />
                  <input
                    type="text"
                    name="year_of_passing"
                    placeholder="Enter year of passing"
                    onChange={handleInputChange}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
                    }}
                    className="border-b-2 border-gray-300 focus:border-sky-600 py-2 px-4 w-full"
                    required
                  />
                </div>

                {/* Grid for Passport Size Photo, Resume, and Major Skill */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 mb-1"
                      htmlFor="photo"
                    >
                      Passport Size Photo
                    </label>
                    <label className="cursor-pointer flex items-center justify-center border border-gray-300 py-2 px-4 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-100 focus:ring-2 focus:ring-offset-2 focus:ring-sky-600">
                      <input
                        type="file"
                        name="photo"
                        id="photo"
                        accept="image/*"
                        className="sr-only" // Hides the original input
                        required
                        onChange={handleFileChange}
                      />
                      {photo === '' ? "Choose File" : photo}
                    </label>
                  </div>

                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 mb-1"
                      htmlFor="resume"
                    >
                      Resume (PDF only)
                    </label>
                    <label className="cursor-pointer flex items-center justify-center border border-gray-300 py-2 px-4 rounded-md shadow-sm text-sm font-medium text-gray-700  bg-white hover:bg-gray-100 focus:ring-2 focus:ring-offset-2 focus:ring-sky-600">
                      <input
                        type="file"
                        name="resume"
                        id="resume"
                        accept=".pdf"
                        className="sr-only " // Hides the original input
                        required
                        onChange={handleFileChange}

                      />
                      {resume === "" ? "Choose File" : resume}
                    </label>
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Major Skill
                    </label>
                    <select
                      name="major_skill"
                      className="border-b-2 border-gray-300 focus:border-sky-600 py-2 px-4 w-full"
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select a skill</option>
                      <option value="Front End">Front End</option>
                      <option value="Back End">Back End</option>
                      <option value="Flutter">Flutter</option>
                      <option value="React Native">React Native</option>
                      <option value="Web">Web</option>
                      <option value="Android">Android</option>
                      <option value="UI/UX">UI/UX</option>
                      <option value="Management">Management</option>
                      <option value="Sales and Marketing">
                        Sales and Marketing
                      </option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full py-3 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition"
                >
                  Submit Application
                </button>
              </form>
            </div>

            {/* Contact Details */}
            <div className="w-full max-w-2xl xl:w-1/3 ">
              <div className="bg-sky-100 p-6 rounded-lg shadow-lg">
                <div className="flex items-center mb-4">
                  <i className="fas fa-envelope text-sky-600 text-2xl mr-4"></i>
                  <div>
                    <span className="font-bold text-xl">Email:</span>
                    <p className="text-gray-700">
                      Our HR team will get back to you within 48 hours.
                    </p>
                    <a
                      href="mailto:hr@versai.in"
                      className="text-sky-600 hover:underline"
                    >
                      HR@versai.in
                    </a>
                  </div>
                </div>
              </div>
              <img
                className="mt-8 md:mt-36 hidden xl:block w-ful object-cover lg:mt-20"
                src={side}
                alt="Side"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareerPage;
